import { MeetingRoomDetailsCardBottom } from "src/components/organisms/meetingRoom/MeetingRoomDetailsCardBottom/MeetingRoomDetailsCardBottom";
import { StyledBottomContainer } from "./styles";
import { HaNCardBottomProps } from "./types";
import {
  useAppSelector,
  MeetingRoom,
  RoomResource,
  getIsMeetingsCalendarActive,
  getMeetingRoomDynamicFreeTimeslot,
  getSuggestionDataForRoomIdForRequest,
} from "@lib/store";
import { useActiveMeetingRoomRequest } from "src/components/pages/HereAndNow/Context/hooks/useActiveMeetingRoomRequest";

const isResource = (room: MeetingRoom | RoomResource): room is RoomResource => {
  return "data" in room;
};

export const HaNCardBottom = ({
  room,
  startDateTime,
  duration,
  onBookNowCallback,
  setPage,
  className,
}: HaNCardBottomProps) => {
  const isMeetingsCalendarActive = useAppSelector(getIsMeetingsCalendarActive);
  const email = isResource(room) ? (room.data.email ?? "") : room.email;
  const activeRequest = useActiveMeetingRoomRequest();

  const meetingRoomSuggestion = useAppSelector(state =>
    getSuggestionDataForRoomIdForRequest(state, activeRequest, room.id),
  );
  const dynamicTimeslot = useAppSelector(state =>
    getMeetingRoomDynamicFreeTimeslot(state, activeRequest, room.id, startDateTime, {
      minutes: duration,
    }),
  );

  const isRoomBookable = !!email && isMeetingsCalendarActive;

  return isRoomBookable ? (
    <StyledBottomContainer className={className}>
      <MeetingRoomDetailsCardBottom
        dynamicTimeslot={dynamicTimeslot}
        meetingRoomSuggestion={meetingRoomSuggestion}
        room={room}
        onBookingDetailsPress={() => setPage("bookingDetails")}
        onBookNowCallback={onBookNowCallback}
      />
    </StyledBottomContainer>
  ) : (
    <></>
  );
};
